<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {showAlert} from "src/components/cabinet/#common/alert/store"
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import {confirmIPByCode} from 'src/components/cabinet/#services/account'

    let code
    let verifySending = false
    let lostDeviceSending = false

    async function verifyCodeHandler() {
        try {
            verifySending = true
            await confirmIPByCode.request({ data: { code } })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            verifySending = false
        }
    }
</script>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <Alert/>
            <div class="page-title">Confirm your login</div>
            <div class="text">You've logged into the Realis account from a new IP address. Please check the confirmation email.</div>
            <input type="text" class="form-control qr-code-field" bind:value={code} placeholder="Enter code">
            <button class="btn btn-primary" class:loading={verifySending} on:click={verifyCodeHandler}><span>Confirm</span></button>
            <!--<div class="text-center">
                <button class="btn lost-device-btn" class:loading={lostDeviceSending} on:click={lostDeviceHandler}
                        disabled={lostDeviceSending}>Lost your authentication device?</button>
            </div>-->
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .text {
        margin: 90px auto 30px;
        text-align: center;
        max-width: 550px;
    }

    .qr-code-field {
        max-width: 250px;
        text-align: center;
        box-shadow: inset 0 0 0 2px #c2c2c3;
        margin: 10px auto 22px;
    }

    .btn-primary {
        display: table;
        min-width: 250px;
        margin: 0 auto;
    }

    .lost-device-btn {
        background: none !important;
        border: 0;
        color: #afb1b3;
        font-size: 15px;
        margin: 15px 0 0;
        transition: .25s;
        box-shadow: none !important;
    }

    .lost-device-btn:hover {
        color: #cfd1d2;
    }

    @media(max-width: 768px) {
        .text {
            margin: 30px auto;
        }
    }
</style>
